export const WIZARD_PROGRESS_SIZE = 34;
